/* eslint-disable no-imports/outside-special-folder */
import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useTranslation } from 'app/lang';
import { getBackendServerUrl } from 'app/ssr/utils';

import dictionary from './Seo.dictionary.json';

export const Seo = () => {
  const { t, lang } = useTranslation();

  return (
    <Helmet>
      <html lang={lang} />

      <title>{t(dictionary.title)}</title>
      <meta name="description"
            content={t(dictionary.description)} />

      <link rel="canonical"
            href={getBackendServerUrl()} />
    </Helmet>
  );
};
